import { Grid } from "@mui/material";
import { CheckInPanelWithSnackbar } from "../../checkin/CheckInPanel";
import { BookingCheckInVO } from "../../../types/model/valueObject/booking/BookingCheckInVO";
import { ReportDialogWrapperProps } from "../../../interfaces";


export const dialogs = Object.freeze({
  CHECK_IN: "CHECK_IN",
});

const SupplierBookingCheckInDialogWrapper = ({
  dialog,
  onClose
}: ReportDialogWrapperProps<BookingCheckInVO>) => {

  const isOpen = (dialogType: string) => {
    return dialog?.dialog === dialogType && Boolean(dialog?.item)
  }

  return <Grid>
    <CheckInPanelWithSnackbar open={isOpen(dialogs.CHECK_IN)} item={dialog?.item} onClose={onClose} />
  </Grid>
}

export { SupplierBookingCheckInDialogWrapper };